import ConsentPromptApp from './ConsentPromptApp'

export default ConsentPromptApp
